//import axios          from "axios";
//import { api }        from "../_constants";
//import handleResponse from "./handleResponse";
//import getVoucherUser from "./handleVoucherUser";
//import getVoucherData from "./handleVoucherData";

import countryLanguages                from './staticData/countryLanguages.json';
import userGenders                     from './staticData/userGenders.json';
import phonePrefixes                   from './staticData/phone-prefixesV2.json';
//import userProfessionsv2               from './staticData/userProfessionsv2.json';
import userProfessionsv2               from './staticData/userProfessionsv4.json';
import positionLevel                   from './staticData/positionLevel.json';
import paymentReasonsV2                from './staticData/paymentReasonsV2.json';
import sourceOfFunds                   from './staticData/sourceOfFunds.json';
import relationshipWithReceiver        from './staticData/relationshipWithReceiver.json';
import behalfThirdParty                from './staticData/behalfThirdParty.json';
import paymentMethod                   from './staticData/paymentMethod.json'

import cached_countries                from './staticData/cached_countries.json'
import cached_currencies               from './staticData/cached_currencies.json'
import cached_locations                from './staticData/cached_locations.json'

import locales_gr                      from './locales/gr/translations_wu_gr.json';
import locales_en                      from './locales/en/translations_wu_en.json';

export const wu_StaticDataService = {
  wu_getLanguages,
  wu_getGenders,
  wu_getPhonePrefixes,
  wu_getProfessions,
  wu_getPositionLevel,
  wu_getPaymentReasons,
  wu_getSourceOfFunds,
  wu_getRelationshipWithReceiver,
  wu_getBehalfThirdParty,
  wu_getPaymentMethods,
  wu_get_cached_countries,
  wu_get_cached_currencies,
  wu_get_cached_locations,
  wu_getLocales_gr,
  wu_getLocales_en,
};
//----------------------------------------------------------------------------------------------------
function wu_getLanguages(reqData) {
  //const methName = "wu_getLanguages ";
  //console.log(methName+"countryLanguages="+JSON.stringify(countryLanguages));
  localStorage.setItem("countryLanguages",                  JSON.stringify(countryLanguages));
  localStorage.setItem("countryLanguages_RetrieveLastDate", new Date());
  return countryLanguages;
}
//----------------------------------------------------------------------------------------------------
function wu_getGenders(reqData) {
  //const methName = "wu_getGenders ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return userGenders;
}
//----------------------------------------------------------------------------------------------------
function wu_getPhonePrefixes(reqData) {
  //const methName = "wu_getPhonePrefixes ";
  //console.log(methName+"userGenders="+JSON.stringify(phonePrefixes));
  localStorage.setItem("phonePrefixes",                  JSON.stringify(phonePrefixes));
  localStorage.setItem("phonePrefixes_RetrieveLastDate", new Date());
  return phonePrefixes;
}
//----------------------------------------------------------------------------------------------------
function wu_getProfessions(reqData) {
  //const methName = "wu_getProfessions ";
  //console.log(methName+"userGenders="+JSON.stringify(userProfessionsv2));
  localStorage.setItem("userProfessionsv2",                  JSON.stringify(userProfessionsv2));
  localStorage.setItem("userProfessionsv2_RetrieveLastDate", new Date());
  return userProfessionsv2;
}
//----------------------------------------------------------------------------------------------------
function wu_getPositionLevel(reqData) {
  //const methName = "wu_getPositionLevel ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  localStorage.setItem("positionLevel",                  JSON.stringify(positionLevel));
  localStorage.setItem("positionLevel_RetrieveLastDate", new Date());
  return positionLevel;
}
//----------------------------------------------------------------------------------------------------
function wu_getPaymentReasons(reqData) {
  //const methName = "wu_getPaymentReasons ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return paymentReasonsV2;
}
//----------------------------------------------------------------------------------------------------
function wu_getBehalfThirdParty(reqData) {
  //const methName = "wu_getBehalfThirdParty ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return behalfThirdParty;
}
//----------------------------------------------------------------------------------------------------
function wu_getSourceOfFunds(reqData) {
  //const methName = "wu_getSourceOfFunds ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return sourceOfFunds;
}
//----------------------------------------------------------------------------------------------------
function wu_getRelationshipWithReceiver(reqData) {
  //const methName = "wu_getRelationshipWithReceiver ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return relationshipWithReceiver;
}
//----------------------------------------------------------------------------------------------------
function wu_getPaymentMethods(reqData) {
  //const methName = "wu_getPaymentMethods ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return paymentMethod;
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function wu_get_cached_countries(reqData) {
  //const methName = "wu_get_cached_countries ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return cached_countries;
}
//----------------------------------------------------------------------------------------------------
function wu_get_cached_currencies(reqData) {
  //const methName = "wu_get_cached_currencies ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return cached_currencies;
}
//----------------------------------------------------------------------------------------------------
function wu_get_cached_locations(reqData) {
  //const methName = "wu_get_cached_locations ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return cached_locations;
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function wu_getLocales_gr(reqData) {
  //const methName = "wu_getLocales_gr ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return locales_gr;
}
//----------------------------------------------------------------------------------------------------
function wu_getLocales_en(reqData) {
  //const methName = "wu_getLocales_en ";
  //console.log(methName+"userGenders="+JSON.stringify(userGenders));
  return locales_en;
}
//----------------------------------------------------------------------------------------------------
